
export default function OutOfApp() {
  sessionStorage.clear()
  window.location.href = './'
}
